module.exports = __webpack_public_path__ + "images/company/rank_medal/assessment_achievement_count_rank/2_8e81ad641cf22bf6bdf56972d4c742e2.png";